import './lib/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tailwind.css';
import './styles/index.css';
import { wrapGlobalFetchForMetrics } from './lib/net-tap';
import { installStaleChunkRecovery } from './lib/chunkRecovery';

// Install deployment/PWA recovery before lazy routes can request chunks.
installStaleChunkRecovery();

// Initialize network instrumentation before app starts
wrapGlobalFetchForMetrics();

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then(registration => {
        console.log(
          '✅ Service Worker registered successfully:',
          registration.scope
        );

        // Detectar actualizaciones del service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.log(
                '🔄 Nueva versión disponible. Recarga para actualizar.'
              );
              // El componente PWAInstallPrompt manejará la notificación visual
              // Enviar referencia del registration para que pueda acceder a waiting worker
              window.dispatchEvent(
                new CustomEvent('sw-update-available', {
                  detail: { registration },
                })
              );
            }
          });
        });
      })
      .catch(error => {
        console.error('❌ Error registering service worker:', error);
      });
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
